/* eslint-disable no-param-reassign */
import axios from 'axios';
import { getApiServerUrl } from './features/configuration/selectors';


const configureAxios = (store) => {
  const apiServerUrl = getApiServerUrl(store.getState());
  return axios.create({
    baseURL: apiServerUrl,
  });
};


export default configureAxios;
